import React from 'react';
import ContactForm from '../../MicrospecDynamicUI/Pages/SectionsMapper/Contact/ContactForm';
import { ContactFormSpec } from '../../MicrospecDynamicUI/Pages/SectionsMapper/Contact/ContactForm/types';

const spec: ContactFormSpec = {
    id: 'contact',
    collectionToStoreTo: `organizations/${process.env.REACT_APP_ORGANIZATION_ID}/branches/${process.env.REACT_APP_BRANCH_ID}/contactSubmissions`,
    sectionTitle: { localizationObject: { type: 'Literal', text: 'צור קשר' } },
    submitButtonText: { localizationObject: { type: 'Literal', text: 'שלח פנייה' } },
    clearButtonText: { localizationObject: { type: 'Literal', text: 'נקה טופס' } },
    successMessage: { localizationObject: { type: 'Literal', text: 'תודה! פנייתך התקבלה. ניצור קשר בהקדם.' } },
    fields: [
        {
            key: 'fullName',
            label: { localizationObject: { type: 'Literal', text: 'שם מלא' } },
            type: 'text',
            required: true,
        },
        {
            key: 'phone',
            label: { localizationObject: { type: 'Literal', text: 'טלפון' } },
            type: 'text',
            required: true,
            regex: '^[0-9+\\-\\s]{7,15}$',
        },
        {
            key: 'email',
            label: { localizationObject: { type: 'Literal', text: 'דוא"ל' } },
            type: 'text',
            required: false,
            regex: '^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$',
        },
        {
            key: 'inquiryType',
            label: { localizationObject: { type: 'Literal', text: 'סוג פנייה' } },
            type: 'dropdown',
            required: true,
            defaultValueIndex: 0,
            setOfValues: [
                { label: { localizationObject: { type: 'Literal', text: 'בקשת הצעת מחיר' } }, value: 'quote' },
                { label: { localizationObject: { type: 'Literal', text: 'שאלה על מוצר' } }, value: 'product_question' },
                { label: { localizationObject: { type: 'Literal', text: 'הזמנה קיימת' } }, value: 'existing_order' },
                { label: { localizationObject: { type: 'Literal', text: 'שיתוף פעולה עסקי' } }, value: 'business' },
                { label: { localizationObject: { type: 'Literal', text: 'אחר' } }, value: 'other' },
            ],
        },
        {
            key: 'message',
            label: { localizationObject: { type: 'Literal', text: 'פרטי הפנייה' } },
            type: 'text',
            required: true,
            multiline: true,
        },
    ],
};

const CommonContactForm: React.FC = () => {
    return <ContactForm spec={spec} />;
};

export default CommonContactForm;

